export default __webpack_public_path__ + "static/media/calendarAdd.a36f1f33.svg";